import { useState } from 'react'
import { MenuButton, type MenuItemProps } from '../Button'
import * as S from './styles'

import Authorize from 'components/Authorize'
import { PERMISSIONS } from '../../../../../constants'

import { Icon, IconName, Typography } from '@themenu/design-system'
import Link from 'next/link'
import { useRouter } from 'next/router'

export type GroupProps = {
  group_name: string
  group_permissions: PERMISSIONS[]
  icon: string
  group_list?: MenuItemProps[]
  href?: string
  id?: string
  target_new?: boolean
  action?: () => void
}

export const GroupItem = ({
  group_name,
  icon,
  group_list,
  group_permissions,
  href,
  id,
  target_new = false
}: GroupProps) => {
  const { route } = useRouter()
  let open = false

  if (
    group_list &&
    !!group_list.filter((list_item) => list_item.href === route).length
  ) {
    open = true
  }

  const [isOpen, setIsOpen] = useState(open)

  const handleToggle = () => {
    setIsOpen((isOpen) => !isOpen)
  }

  const typeItem = () => {
    if (href) {
      if (target_new) {
        return (
          <Authorize permissions={group_permissions}>
            <Link
              id={id}
              className="flex items-center gap-12 px-14 py-8 hover:bg-background-default rounded-8 mb-8"
              href={href}
              target="_blank"
            >
              <Icon name={icon as IconName} size={16} className="mb-[2px]" />
              <Typography variant="callout">{group_name}</Typography>
            </Link>
          </Authorize>
        )
      }

      const active = route.startsWith(href)

      return (
        <Authorize permissions={group_permissions}>
          <Link
            id={id}
            className={`flex items-center gap-12 px-14 py-8 hover:bg-background-default rounded-8 mb-4
              ${active ? 'bg-background-default' : ''}`}
            href={href}
          >
            <Icon
              name={icon as IconName}
              size={16}
              className={`mb-[2px]
                ${
                  active
                    ? 'svg-children:stroke-content-primary svg-children:fill-content-primary'
                    : ''
                }`}
            />
            <Typography
              variant="callout"
              className={active ? 'text-content-primary' : ''}
            >
              {group_name}
            </Typography>
          </Link>
        </Authorize>
      )
    }

    return (
      <Authorize permissions={group_permissions}>
        <S.Name
          role="radio"
          aria-checked={isOpen ? 'true' : 'false'}
          onClick={handleToggle}
        >
          <div className="flex">
            <Icon
              name={icon as IconName}
              size={16}
              className="mb-[2px] mr-10"
            />
            <Typography variant="callout">{group_name}</Typography>
          </div>
          <Icon name="chevron-down" size={16} className="mb-[2px]" />
        </S.Name>
      </Authorize>
    )
  }

  return (
    <>
      {href ? (
        typeItem()
      ) : (
        <S.Item key={group_name} isOpen={isOpen}>
          {typeItem()}
          {group_list && group_list.length > 0 && (
            <ul>
              {group_list.map((props) => (
                <Authorize key={props.label} permissions={props.permission}>
                  <MenuButton {...props} />
                </Authorize>
              ))}
            </ul>
          )}
        </S.Item>
      )}
    </>
  )
}
